import DetailTransferListTable from './DetailTransferListTable';

export default DetailTransferListTable;
